import { render, staticRenderFns } from "./RecommendCars.vue?vue&type=template&id=0a082d4f&scoped=true&"
import script from "./RecommendCars.vue?vue&type=script&lang=js&"
export * from "./RecommendCars.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCars.vue?vue&type=style&index=0&id=0a082d4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a082d4f",
  null
  
)

export default component.exports